import { GetterTree } from "vuex";
import { State } from "..";

export type Getters = {};

export const getters: GetterTree<State, State> & Getters = {};
